import React from 'react';
import PropTypes from 'prop-types';

const IconCircleSuccess = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3265 29.1012L30.8839 14.5439L29.1161 12.7761L16.3265 25.5657L10.8839 20.1231L9.11612 21.8908L16.3265 29.1012Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2.5C10.0589 2.5 2 10.5589 2 20.5C2 30.4411 10.0589 38.5 20 38.5C29.9411 38.5 38 30.4411 38 20.5C38 10.5589 29.9411 2.5 20 2.5ZM4.5 20.5C4.5 11.9396 11.4396 5 20 5C28.5604 5 35.5 11.9396 35.5 20.5C35.5 29.0604 28.5604 36 20 36C11.4396 36 4.5 29.0604 4.5 20.5Z"
        fill="black"
      />
    </svg>
  );
};

IconCircleSuccess.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconCircleSuccess.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconCircleSuccess;
